/* ZEPHIR - Capa editorial de la ficha de producto.
 *   A) Columna de fotos a sangre por la izquierda.
 *   B) Reticula de la galeria por ciclos (ver CICLO).
 *   C) Barra fija de compra: de abajo-centrada a arriba-a lo ancho.
 *   D) Acordeones al alto de la referencia y hairline de la paleta.
 *
 * (B) ES JS Y NO :nth-child PORQUE:
 *   La galeria la posiciona PACKERY en absoluto (window.Packery; la clase se
 *   llama isotopet4s pero Isotope es undefined). Cada foto trae inline
 *   "position:absolute; top:845.26px". Entonces:
 *     1. Cambiar anchos por CSS no reacomoda: hay que llamar layout().
 *     2. Al filtrar por color las ocultas salen del layout, y :nth-child cuenta
 *        TODOS los hermanos. El ciclo se calcula sobre las VISIBLES.
 *
 * DOS CORTES, NO UNO. La reticula y la barra no comparten ancho minimo:
 *   MIN_GRID 992 - reticula y sangrado. El tema pone dos columnas desde 768
 *     (t4s-col-md-6, verificado en base.css), asi que entre 768 y 991 la
 *     columna de fotos mide ~370px y una foto a media anchura quedaria en
 *     ~180px: ilegible. Ahi se deja la columna completa, que es lo que hace
 *     tambien la referencia en tablet.
 *   MIN_BAR 768 - barra fija y acordeones. Es un elemento superpuesto, no
 *     depende del ancho de la columna, y va acompasado con zephir-pdp-rl.js,
 *     que enciende la barra desde 768. Si los dos numeros se separan queda un
 *     estado a medias: la barra aparece abajo (posicion del tema) con la
 *     animacion de opacidad puesta.
 */
(function () {
  'use strict';

  var SEL = '[data-main-slide]', CLASE = 'zph-g-half';
  var MIN_GRID = 992, propio = false;   // 992: tambien en zephir-pdp-capa.css

  /* CICLO: cada ciclo cierra con DOS fotos a media anchura; las previas completas.
   *   4 -> completa, completa, mitad, mitad   (ritmo de la referencia)
   *   3 -> completa, mitad, mitad             (el de aqui)
   * Se usa 3 porque con el filtro por color cada color muestra solo SUS fotos y
   * ZEPHIR tiene 1-3 por color: con 4 el par casi nunca aparecia. Subirlo
   * cuando haya mas fotos por color es cambiar este numero y nada mas. */
  var CICLO = 3;

  /* EL CSS DE ESTE ARCHIVO (media anchura de la reticula, sangrado, barra fija
   * arriba y acordeones) VIVE EN assets/zephir-pdp-capa.css, cargado antes de
   * pintar. Antes se inyectaba desde aqui y la ficha se pintaba primero con el
   * aspecto del tema y luego cambiaba: medido 2026-10-08, CLS 0,73 en escritorio.
   * Aqui queda solo el calculo del ciclo, que si necesita JS (ver arriba).
   * La clase que se pone es zph-g-half; su regla esta en ese CSS. */

  function cont() { var i = document.querySelector(SEL); return i ? i.parentElement : null; }

  function inst(c) {
    try {
      if (window.Packery && typeof window.Packery.data === 'function') {
        var p = window.Packery.data(c);
        if (p && typeof p.layout === 'function') return p;
      }
    } catch (e) {}
    return null;
  }

  function aplicar() {
    var c = cont();
    if (!c) return false;
    var todas = [].slice.call(c.querySelectorAll(SEL));
    if (!todas.length) return false;

    var p = inst(c);
    // Sin packery: carrusel (movil) o aun no arranco. No tocar anchos.
    var activo = !!p && window.innerWidth >= MIN_GRID;

    propio = true;
    todas.forEach(function (el) { el.classList.remove(CLASE); });
    if (activo) {
      var vis = todas.filter(function (el) { return !el.classList.contains('is--media-hide'); });
      // Las DOS ultimas posiciones de cada ciclo van a media anchura.
      vis.forEach(function (el, i) { if (i % CICLO >= CICLO - 2) el.classList.add(CLASE); });
      // Ciclo final incompleto por una posicion: esa mitad quedaria sola.
      if (vis.length % CICLO === CICLO - 1) vis[vis.length - 1].classList.remove(CLASE);
    }
    propio = false;

    if (p) { try { p.layout(); } catch (e) {} }
    return activo;
  }

  var n = 0;
  function arrancar() { if (aplicar() || ++n > 30) { observar(); return; } setTimeout(arrancar, 250); }

  // El filtro por color mueve is--media-hide: recalcular sobre las visibles.
  function observar() {
    var c = cont();
    if (!c || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function (ms) {
      if (propio) return;
      var ok = ms.some(function (m) {
        return m.type === 'attributes' && m.attributeName === 'class' &&
               m.target.hasAttribute && m.target.hasAttribute('data-main-slide');
      });
      if (!ok) return;
      clearTimeout(t);
      t = setTimeout(aplicar, 60);
    }).observe(c, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  var r = null;
  window.addEventListener('resize', function () { clearTimeout(r); r = setTimeout(aplicar, 200); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
